import React, { useEffect } from 'react';
import styled from '@emotion/styled/macro';
import * as d3 from 'd3';
import { PieChartProps } from './pie-chart.types';

const PieChart: React.FC<PieChartProps> = ({
  pieData,
  width = 450,
  height = 450,
  margin = 40,
  innerRadius = 0,
  className,
}) => {
  const outerRadius = Math.min(width, height) / 2 - margin;

  useEffect(() => {
    const drawChart = () => {
      d3.select('#pie-container').select('svg').remove();

      const svg = d3
        .select('#pie-container')
        .append('svg')
        .attr('height', height)
        .attr('width', width)
        .append('g')
        .attr('transform', `translate(${width / 2}, ${height / 2})`);

      const arcGenerator = d3
        .arc()
        .innerRadius(innerRadius)
        .outerRadius(outerRadius);

      const pieGenerator = d3
        .pie()
        .padAngle(0)
        .value(d => d.value);

      const arc = svg.selectAll().data(pieGenerator(pieData)).enter();

      arc
        .append('path')
        .attr('d', arcGenerator)
        .style('fill', d => d.data.colour)
        .style('stroke', '#ffffff')
        .style('stroke-width', 2);
    };
    drawChart();
  });

  if (pieData) {
    return (
      <div className={className} id="pie-container" data-testid="pie-chart" />
    );
  } else {
    console.warn('Pie Chart component called with falsy prop. data:' + pieData);
    return null;
  }
};

const StyledPieChart = styled(PieChart)`
  #pie-container {
    width: 100%;
    height: 100%;
    flex-basis: 25%;
  }
`;

export default StyledPieChart;
